import { OnboardingDataType } from '../../config';

export enum IdDocumentType {
  NationalId = 'NationalId',
}

export enum BiometricType {
  Face = 'Face',
}

export enum ContactType {
  Phone = 'Phone',
  Email = 'Email',
  PhysicalAddress = 'physicalAddress',
}

export enum FinancialAccountType {
  MobileMoney = 'mobileMoney',
  BankAccount = 'bankAccount',
}

const ID_DOCUMENT = 'ID DOCUMENT';
const BIOMETRIC = 'BIOMETRIC';
const CONTACT = 'CONTACT';
const ACCOUNT_TYPE = 'ACCOUNT TYPE';
const DATA_TYPE = 'DATA TYPE';
const VERIFIABLE = 'VERIFIABLE';
const CAPTURE = 'CAPTURE';
const VERIFY = 'VERIFY FIELD';
const REQUIRE = 'REQUIRE';

export const idDocumentsTable = {
  columns: [ID_DOCUMENT, DATA_TYPE, VERIFIABLE, CAPTURE, VERIFY, REQUIRE],
  rows: [
    {
      key: IdDocumentType.NationalId,
      title: 'NATIONAL ID',
      dataType: OnboardingDataType.Image,
      isVerifiable: true,
      verificationExplanation: 'The information captured in this step can be verified with the National Identity Registration Authority (NIRA) of Uganda.',
      captureFieldName: 'captureNationalId',
      verifyFieldName: 'verifyNationalId',
      requiredFieldName: 'requireNationalId',
    }
  ]
};

export const biometricsTable = {
  columns: [BIOMETRIC, DATA_TYPE, VERIFIABLE, CAPTURE, VERIFY, REQUIRE],
  rows: [
    {
      key: BiometricType.Face,
      title: 'SELFIE',
      dataType: OnboardingDataType.Image,
      isVerifiable: true,
      verificationExplanation: 'The image capture process will include a liveliness check. This ensures that the image captured is of a living person and not another photograph.',
      captureFieldName: 'captureFace',
      verifyFieldName: 'verifyFace',
      requiredFieldName: 'requireFace',
    }
  ]
};

export const contactsTable = {
  columns: [CONTACT, DATA_TYPE, VERIFIABLE, CAPTURE, VERIFY, REQUIRE],
  rows: [
    {
      key: ContactType.Phone,
      title: 'PHONE NUMBER',
      dataType: OnboardingDataType.Phone,
      isVerifiable: true,
      verificationExplanation: 'Ugandan phone numbers can be verified with MTN Uganda or Airtel Uganda.',
      captureFieldName: 'capturePhoneNumber',
      verifyFieldName: 'verifyPhoneNumber',
      requiredFieldName: 'requirePhoneNumber',
    },
    {
      key: ContactType.Email,
      title: 'EMAIL',
      dataType: OnboardingDataType.Email,
      isVerifiable: true,
      verificationExplanation: 'If selected, we will collect an email address from your customer and request that they verify ownership using an OTP.',
      captureFieldName: 'captureEmailAddress',
      verifyFieldName: 'verifyEmailAddress',
      requiredFieldName: 'requireEmailAddress',
    },
    {
      key: ContactType.PhysicalAddress,
      title: 'PHYSICAL ADDRESS',
      dataType: OnboardingDataType.Text,
      isVerifiable: false,
      verificationExplanation: 'This is the information we shall show to the customer',
      captureFieldName: 'capturePhysicalAddress',
      verifyFieldName: 'verifyPhysicalAddress',
      requiredFieldName: 'requirePhysicalAddress',
    }
  ]
};

export const financialTable = {
  columns: [ACCOUNT_TYPE, DATA_TYPE, VERIFIABLE, CAPTURE, VERIFY, REQUIRE],
  rows: [
    {
      key: FinancialAccountType.MobileMoney,
      title: 'MOBILE MONEY',
      dataType: OnboardingDataType.Phone,
      isVerifiable: true,
      verificationExplanation: 'If selected, we will collect a phone number from your customer and request that they verify ownership using an OTP.',
      captureFieldName: 'captureMobileMoneyNumber',
      verifyFieldName: 'verifyMobileMoneyNumber',
      requiredFieldName: 'requireMobileMoneyNumber',
    },
    {
      key: FinancialAccountType.BankAccount,
      title: 'BANK ACCOUNT',
      dataType: OnboardingDataType.Number,
      isVerifiable: false,
      verificationExplanation: 'This is the information we shall show to the customer',
      captureFieldName: 'captureBankAccount',
      verifyFieldName: 'verifyBankAccount',
      requiredFieldName: 'requireBankAccount',
    }
  ]
};
